// // // // import React, { useState } from "react";
// // // // import "./NavBar.css";
// // // // import ContactModal from "./ContactModal";

// // // // export default function NavBar() {
// // // //   const [showModal, setShowModal] = useState(false);

// // // //   return (
// // // //     <header className="nav-bar">
// // // //       <div
// // // //         className="hamburger"
// // // //         onClick={() => setShowModal(false)} // close modal if open
// // // //       >
// // // //         <span></span>
// // // //         <span></span>
// // // //         <span></span>
// // // //       </div>

// // // //       <nav className="nav-left">
// // // //         <a href="/">Home</a>
// // // //         <a href="/portfolio">Portfolio</a>
// // // //         <a href="/posts">Blogs</a>
// // // //         <a href="/resume">Résumé</a>
// // // //         <a href="/avsync">AV Sync</a>
// // // //         <a href="/avsync/docs">AV Sync Docs</a>
// // // //       </nav>

// // // //       <button className="contact-btn" onClick={() => setShowModal(true)}>
// // // //         Contact Me
// // // //       </button>

// // // //       {/* Modal */}
// // // //       <ContactModal isOpen={showModal} onClose={() => setShowModal(false)} />
// // // //     </header>
// // // //   );
// // // // }
// // // import React, { useEffect, useRef, useState } from "react";
// // // import "./NavBar.css";
// // // import ContactModal from "./ContactModal";

// // // export default function NavBar() {
// // //   const [showModal, setShowModal] = useState(false);
// // //   const [portfolioOpen, setPortfolioOpen] = useState(false);
// // //   const dropdownRef = useRef(null);

// // //   // close dropdown when clicking outside
// // //   useEffect(() => {
// // //     function handleClickOutside(e) {
// // //       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
// // //         setPortfolioOpen(false);
// // //       }
// // //     }
// // //     document.addEventListener("mousedown", handleClickOutside);
// // //     return () => document.removeEventListener("mousedown", handleClickOutside);
// // //   }, []);

// // //   return (
// // //     <header className="nav-bar">
// // //       <div
// // //         className="hamburger"
// // //         onClick={() => {
// // //           setShowModal(false);
// // //           setPortfolioOpen(false);
// // //         }}
// // //       >
// // //         <span></span>
// // //         <span></span>
// // //         <span></span>
// // //       </div>

// // //       <nav className="nav-left">
// // //         <a href="/">Home</a>

// // //         {/* Portfolio Dropdown */}
// // //         <div className="nav-dropdown" ref={dropdownRef}>
// // //           <button
// // //             type="button"
// // //             className="nav-link-btn"
// // //             onClick={() => setPortfolioOpen((v) => !v)}
// // //             aria-haspopup="menu"
// // //             aria-expanded={portfolioOpen}
// // //           >
// // //             PORTFOLIO <span className="nav-caret">▾</span>
// // //           </button>

// // //           {portfolioOpen && (
// // //             <div className="dropdown-menu" role="menu">
// // //               <a
// // //                 className="dropdown-item"
// // //                 href="/portfolio"
// // //                 onClick={() => setPortfolioOpen(false)}
// // //               >
// // //                 All Projects
// // //               </a>
// // //               <a
// // //                 className="dropdown-item"
// // //                 href="/avsync"
// // //                 onClick={() => setPortfolioOpen(false)}
// // //               >
// // //                 AV Sync
// // //               </a>
// // //               <a
// // //                 className="dropdown-item"
// // //                 href="/avsync/docs"
// // //                 onClick={() => setPortfolioOpen(false)}
// // //               >
// // //                 AV Sync Docs
// // //               </a>
// // //             </div>
// // //           )}
// // //         </div>

// // //         <a href="/posts">Blogs</a>
// // //         <a href="/resume">Résumé</a>
// // //       </nav>

// // //       <button
// // //         className="contact-btn"
// // //         onClick={() => {
// // //           setShowModal(true);
// // //           setPortfolioOpen(false);
// // //         }}
// // //       >
// // //         Contact Me
// // //       </button>

// // //       <ContactModal isOpen={showModal} onClose={() => setShowModal(false)} />
// // //     </header>
// // //   );
// // // }

// // import React, { useEffect, useRef, useState } from "react";
// // import "./NavBar.css";
// // import ContactModal from "./ContactModal";

// // export default function NavBar() {
// //   const [showModal, setShowModal] = useState(false);
// //   const [portfolioOpen, setPortfolioOpen] = useState(false);
// //   const [menuOpen, setMenuOpen] = useState(false); // ✅ NEW
// //   const dropdownRef = useRef(null);

// //   useEffect(() => {
// //     function handleClickOutside(e) {
// //       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
// //         setPortfolioOpen(false);
// //       }
// //     }
// //     document.addEventListener("mousedown", handleClickOutside);
// //     return () => document.removeEventListener("mousedown", handleClickOutside);
// //   }, []);

// //   const closeMenus = () => {
// //     setMenuOpen(false);
// //     setPortfolioOpen(false);
// //   };

// //   return (
// //     <header className="nav-bar">
// //       {/* ✅ Make hamburger a real button + toggle menuOpen */}
// //       <button
// //         type="button"
// //         className="hamburger"
// //         aria-label="Open menu"
// //         aria-expanded={menuOpen}
// //         onClick={() => {
// //           setMenuOpen((v) => !v);
// //           setShowModal(false);
// //           setPortfolioOpen(false);
// //         }}
// //       >
// //         <span></span>
// //         <span></span>
// //         <span></span>
// //       </button>

// //       {/* Desktop nav */}
// //       <nav className="nav-left nav-desktop">
// //         <a href="/">Home</a>

// //         <div className="nav-dropdown" ref={dropdownRef}>
// //           <button
// //             type="button"
// //             className="nav-link-btn"
// //             onClick={() => setPortfolioOpen((v) => !v)}
// //             aria-haspopup="menu"
// //             aria-expanded={portfolioOpen}
// //           >
// //             PORTFOLIO <span className="nav-caret">▾</span>
// //           </button>

// //           {portfolioOpen && (
// //             <div className="dropdown-menu" role="menu">
// //               <a
// //                 className="dropdown-item"
// //                 href="/portfolio"
// //                 onClick={() => setPortfolioOpen(false)}
// //               >
// //                 All Projects
// //               </a>
// //               <a
// //                 className="dropdown-item"
// //                 href="/avsync"
// //                 onClick={() => setPortfolioOpen(false)}
// //               >
// //                 AV Sync
// //               </a>
// //               <a
// //                 className="dropdown-item"
// //                 href="/avsync/docs"
// //                 onClick={() => setPortfolioOpen(false)}
// //               >
// //                 AV Sync Docs
// //               </a>
// //             </div>
// //           )}
// //         </div>

// //         <a href="/posts">Blogs</a>
// //         <a href="/resume">Résumé</a>
// //       </nav>

// //       <button
// //         className="contact-btn nav-desktop"
// //         onClick={() => {
// //           setShowModal(true);
// //           closeMenus();
// //         }}
// //       >
// //         Contact Me
// //       </button>

// //       {/* ✅ Mobile menu panel */}
// //       {menuOpen && (
// //         <div className="mobile-menu">
// //           <a href="/" onClick={closeMenus}>
// //             Home
// //           </a>
// //           <a href="/portfolio" onClick={closeMenus}>
// //             All Projects
// //           </a>
// //           <a href="/avsync" onClick={closeMenus}>
// //             AV Sync
// //           </a>
// //           <a href="/avsync/docs" onClick={closeMenus}>
// //             AV Sync Docs
// //           </a>
// //           <a href="/posts" onClick={closeMenus}>
// //             Blogs
// //           </a>
// //           <a href="/resume" onClick={closeMenus}>
// //             Résumé
// //           </a>

// //           <button
// //             className="contact-btn mobile-contact"
// //             onClick={() => {
// //               setShowModal(true);
// //               closeMenus();
// //             }}
// //           >
// //             Contact Me
// //           </button>
// //         </div>
// //       )}

// //       <ContactModal isOpen={showModal} onClose={() => setShowModal(false)} />
// //     </header>
// //   );
// // }

// import React, { useEffect, useRef, useState } from "react";
// import "./NavBar.css";
// import ContactModal from "./ContactModal";

// export default function NavBar() {
//   const [showModal, setShowModal] = useState(false);
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [portfolioOpen, setPortfolioOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   // close dropdown when clicking outside (desktop)
//   // useEffect(() => {
//   //   function handleClickOutside(e) {
//   //     if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//   //       setPortfolioOpen(false);
//   //     }
//   //   }
//   //   document.addEventListener("mousedown", handleClickOutside);
//   //   return () => document.removeEventListener("mousedown", handleClickOutside);
//   // }, []);

//   useEffect(() => {
//     document.body.style.overflow = menuOpen ? "hidden" : "";
//     return () => (document.body.style.overflow = "");
//   }, [menuOpen]);

//   const closeMenu = () => {
//     setMenuOpen(false);
//     setPortfolioOpen(false);
//   };

//   return (
//     <header className="nav-bar">
//       {/* Hamburger */}
//       <button
//         type="button"
//         className={`hamburger ${menuOpen ? "active" : ""}`}
//         aria-label="Toggle navigation"
//         aria-expanded={menuOpen}
//         onClick={() => {
//           setMenuOpen((v) => !v);
//           setShowModal(false);
//           setPortfolioOpen(false);
//         }}
//       >
//         <span></span>
//         <span></span>
//         <span></span>
//       </button>

//       {/* Nav links */}
//       <nav className={`nav-left ${menuOpen ? "open" : ""}`}>
//         <a href="/" onClick={closeMenu}>
//           HOME
//         </a>

//         {/* Portfolio (desktop dropdown, mobile static list) */}
//         <div className="nav-dropdown" ref={dropdownRef}>
//           <button
//             type="button"
//             className="nav-link-btn nav-portfolio-btn"
//             onClick={() => setPortfolioOpen((v) => !v)}
//             aria-haspopup="menu"
//             aria-expanded={portfolioOpen}
//           >
//             PORTFOLIO <span className="nav-caret">▾</span>
//           </button>

//           {/* Desktop dropdown only */}
//           <div
//             className={`dropdown-menu ${portfolioOpen ? "is-open" : ""}`}
//             role="menu"
//           >
//             <a className="dropdown-item" href="/portfolio" onClick={closeMenu}>
//               All Projects
//             </a>
//             <a className="dropdown-item" href="/avsync" onClick={closeMenu}>
//               AV Sync
//             </a>
//             <a
//               className="dropdown-item"
//               href="/avsync/docs"
//               onClick={closeMenu}
//             >
//               AV Sync Docs
//             </a>
//           </div>

//           {/* Mobile static list (always visible when menu is open) */}
//           <div className="mobile-subnav">
//             <a
//               className="mobile-subnav-item"
//               href="/portfolio"
//               onClick={closeMenu}
//             >
//               All Projects
//             </a>
//             <a
//               className="mobile-subnav-item"
//               href="/avsync"
//               onClick={closeMenu}
//             >
//               AV Sync
//             </a>
//             <a
//               className="mobile-subnav-item"
//               href="/avsync/docs"
//               onClick={closeMenu}
//             >
//               AV Sync Docs
//             </a>
//           </div>
//         </div>

//         <a href="/posts" onClick={closeMenu}>
//           BLOGS
//         </a>
//         <a href="/resume" onClick={closeMenu}>
//           RÉSUMÉ
//         </a>
//       </nav>

//       {/* Contact stays OUTSIDE menu (right side) */}
//       <button
//         className="contact-btn"
//         onClick={() => {
//           setShowModal(true);
//           setMenuOpen(false);
//           setPortfolioOpen(false);
//         }}
//       >
//         Contact Me
//       </button>

//       <ContactModal isOpen={showModal} onClose={() => setShowModal(false)} />
//     </header>
//   );
// }

import React, { useEffect, useRef, useState } from "react";
import "./NavBar.css";
import ContactModal from "./ContactModal";

export default function NavBar() {
  const [showModal, setShowModal] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [portfolioOpen, setPortfolioOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close desktop dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setPortfolioOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Prevent background scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [menuOpen]);

  const closeMenu = () => {
    setMenuOpen(false);
    setPortfolioOpen(false);
  };

  return (
    <header className="nav-bar">
      {/* Hamburger */}
      <button
        type="button"
        className={`hamburger ${menuOpen ? "active" : ""}`}
        aria-label="Toggle navigation"
        aria-expanded={menuOpen}
        onClick={() => {
          setMenuOpen((v) => !v);
          setShowModal(false);
          setPortfolioOpen(false);
        }}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Nav links */}
      <nav className={`nav-left ${menuOpen ? "open" : ""}`}>
        <a href="/" onClick={closeMenu}>
          HOME
        </a>

        {/* Portfolio (desktop dropdown, mobile static list) */}
        <div
          className={`nav-dropdown ${portfolioOpen ? "is-open" : ""}`}
          ref={dropdownRef}
        >
          <button
            type="button"
            className="nav-link-btn nav-portfolio-btn"
            onClick={() => setPortfolioOpen((v) => !v)}
            aria-haspopup="menu"
            aria-expanded={portfolioOpen}
          >
            PORTFOLIO <span className="nav-caret">▾</span>
          </button>

          {/* Desktop dropdown only (CSS will hide on mobile) */}
          <div className="dropdown-menu" role="menu">
            <a className="dropdown-item" href="/portfolio" onClick={closeMenu}>
              All Projects
            </a>
            <a className="dropdown-item" href="/avsync" onClick={closeMenu}>
              AV Sync
            </a>
            <a
              className="dropdown-item"
              href="/avsync/docs"
              onClick={closeMenu}
            >
              AV Sync Docs
            </a>
          </div>

          {/* Mobile static list (CSS will show only on mobile) */}
          <div className="mobile-subnav">
            <a
              className="mobile-subnav-item"
              href="/portfolio"
              onClick={closeMenu}
            >
              All Projects
            </a>
            <a
              className="mobile-subnav-item"
              href="/avsync"
              onClick={closeMenu}
            >
              AV Sync
            </a>
            <a
              className="mobile-subnav-item"
              href="/avsync/docs"
              onClick={closeMenu}
            >
              AV Sync Docs
            </a>
          </div>
        </div>

        <a href="/posts" onClick={closeMenu}>
          BLOGS
        </a>
        <a href="/resume" onClick={closeMenu}>
          RÉSUMÉ
        </a>
      </nav>

      {/* Contact stays OUTSIDE menu */}
      <button
        className="contact-btn"
        onClick={() => {
          setShowModal(true);
          setMenuOpen(false);
          setPortfolioOpen(false);
        }}
      >
        Contact Me
      </button>

      <ContactModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </header>
  );
}
